// markdownChat — shared markdown-it + DOMPurify config for chat surfaces.
//
// Both the Assess chat panel (`src/features/assess/chat/ChatMessage.jsx`) and
// the sidebar Chat tab (`src/components/Sidebar/ChatTab.jsx`) render assistant
// messages from model-produced markdown. They both need the same behaviour:
//   - soft-wrapped lines → visual <br> (breaks: true)
//   - bare URLs auto-linked (linkify: true)
//   - no raw HTML execution (html: false)
//   - all links open in a new tab with rel="noopener noreferrer"
//   - sanitize the final HTML via DOMPurify before injecting via
//     dangerouslySetInnerHTML
//
// Keeping the config in one place avoids drift between the two surfaces.

import markdownit from 'markdown-it';
import DOMPurify from 'dompurify';

const md = markdownit({
  html: false,
  breaks: true,
  linkify: true,
  typographer: false,
});

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  tokens[idx].attrSet('target', '_blank');
  tokens[idx].attrSet('rel', 'noopener noreferrer');
  return self.renderToken(tokens, idx, options);
};

/**
 * Render chat-flavoured markdown to a sanitized HTML string.
 * @param {string} text
 * @returns {string} sanitized HTML, safe to use with dangerouslySetInnerHTML.
 */
export function renderChatMarkdown(text) {
  if (!text) return '';
  return DOMPurify.sanitize(md.render(text));
}
